import { assertIsNotNil } from 'common/assertions';
import assertInstanceOf from 'common/assertions/assertInstanceOf';

import Constants from 'lib/Constants';
import StorytellerUtils from 'lib/StorytellerUtils';

import RichTextEditor from './RichTextEditor';
import { FormatController, richTextEditorToolbar } from './RichTextEditorToolbar';

interface RichTextEditorToolbarComponent {
  link(editorFormatController: FormatController | null): void;
  unlink(): void;
  destroy(): void;
}

export default class RichTextEditorManager {
  private formats: (typeof Constants)['RICH_TEXT_FORMATS'];
  private toolbar: RichTextEditorToolbarComponent;
  private editors: { [editorId: string]: RichTextEditor } = {};

  constructor(toolbar: RichTextEditorToolbarComponent, formats: (typeof Constants)['RICH_TEXT_FORMATS']) {
    assertInstanceOf(formats, Array);

    this.toolbar = toolbar;
    this.formats = formats;
  }

  createEditor(element: JQuery<HTMLElement>, editorId: string, contentToPreload?: string): RichTextEditor {
    this.editors[editorId] = new RichTextEditor(element, editorId, this.formats, contentToPreload);

    return this.editors[editorId];
  }

  getEditor(editorId?: string): null | RichTextEditor {
    if (typeof editorId !== 'undefined' && this.editors.hasOwnProperty(editorId)) {
      return this.editors[editorId];
    }

    return null;
  }

  getAllEditors(): { [editorId: string]: RichTextEditor } {
    return this.editors;
  }

  deleteEditor(editorId: string): void {
    this.editors[editorId].destroy();

    delete this.editors[editorId];
  }

  linkToolbar(editorId: string): void {
    const editor = this.getEditor(editorId);
    assertIsNotNil(editor);
    this.toolbar.link(editor.getFormatController());
  }

  unlinkToolbar(): void {
    this.toolbar.unlink();
  }
}

export const richTextEditorManager = StorytellerUtils.export(
  new RichTextEditorManager(richTextEditorToolbar, Constants.RICH_TEXT_FORMATS),
  'storyteller.richTextEditorManager',
);
